export const SERVICES = [
    {
        id: 0,
        name: "Manicure",
        image: "/assets/images/manicure.png",                
        subServices: [
            {
                subName: "Basic Manicure",
                price: 18,
                detail: "This manicure includes nail shaping cuticle grooming and hydration, plus lower and hand massage. Your selection of nail polish adds a personalized touch."
            },
            {
                subName: "Deluxe Manicure",
                price: 25,
                detail: "The manicure plus an additional massage with a luxurious blend of sea salts and that gently scrubs away dull dry skin. Hands are then placed in hot towels, followed by a moisturizing massage. Your selection of polish a personalized touch."
            },
            {
                subName: "Ultimate Manicure",
                price: 32,
                detail: "All that the Deluxe manicure includes. Your choice of different flowers including(jasmine soothe, Mango Delight, Tangerine Twist, Cucumber Fresh, Vitamin Recharge, Lavender Relieve, Olive Sensation, Lemon Quench, Green Tea Detox, Ocean Refresh, and Mojito). This manicure includes a soothing mud mask and an extended lower arm and massage followed by a hot towel wrap. This complete and luxurious experience resembles a facial for your perfectly manicured hands. Your selection of polish adds the finishing touch. Service includes a glass of house wine for our guest 21 and over."
            },
            {
                subName: "Natural Manicure",
                price: 25,
                detail: "A combination of 21 herbs creates an optimal environment for a soothing and relaxing bathing experience while conditioning and nurturing the skin."
            }
        ]
    },
    {
        id: 1,
        name: "Pedicure",
        image: "/assets/images/pedicure.jpg",
        subServices: [
            {
                subName: "Basic Manicure",
                price: 32,
                detail: "This pedicure includes nail shaping, cuticle grooming, and hydration. An additional callus remover is added to soften the feet. A hydrating lower leg foot massage follows, accompanied by a hot towel wrap. Your selection of polish adds a personalized touch."
            },
            {
                subName: "Deluxe Manicure",
                price: 40,
                detail: "The Spa Pedicure plus a sugar scrub that gently exfoliates dry skin and reveals a smoother feel. A hydrating lower leg and foot massage follow, accompanied by a hot towel wrap. Your selection of polish adds a personalized touch."
            },
            {
                subName: "Spa Manicure",
                price: 55,
                detail: "The Spa Pedicure is an extension of the Deluxe Spa Pedicure. This pedicure includes the warm neck pain relief pillow. Your choice of different flavor including (Jasmine soothe, Mango Delight, Tangerine Twist, Cucumber Fresh, Vitamin Recharge, Lavender Relieve, Olive Sensation, Lemon Quench, Green Tea Detox, Ocean Refresh, and Mojito). After moisturizing mud mask and sugar scrub are applied to soften and relieve the skin. An extended massage and hot towel wrap finish the pedicure. Your selection of polish adds a personalized touch. Service includes a glass of house wine for our guests 21 and over."
            },
            {
                subName: "The Ultimate Pedicure",
                price: 75,
                detail: "The most luxurious Nail Spa pedicure for indulgent foot care. This pedicure is an extension of either the Spa Pedicure or the Jelly Pedicure Collection. Plus, an intensely hydrating paraffin treatment and an extended lower leg and foot massage that includes warm, smooth rocks and gently loosens stiff muscles. Allows us to care for your overworked legs and feet while you relax and unwind. Afterward, the feet are wrapped in the hot towels. Your selection of polish adds a personalized touch. Service includes a glass of house wine for our guest 21 and over."
            }
        ]
    },
    {
        id: 2,
        name:"Nail Enhancement",
        image: "/assets/images/nail_enhancement.png",
        subServices: [
            {
                subName: "Regular Acrylic",
                price: 25,
                detail: ""
            },
            {
                subName: "Full Set Acrylic",
                price: 32,
                detail: ""
            },
            {
                subName: "Pink and White",
                price: 50,
                detail: ""
            },
            {
                subName: "Fill Pink and White",
                price: 45,
                detail: ""
            },
            {
                subName: "Powder Gel",
                price: 40,
                detail: ""
            },
            {
                subName: "Fill Acrylic",
                price: 23,
                detail: "Acrylic is the most durable form of nail enhancement. Recommended for those who constantly work with their hands. It is the most popular form of artificial nails due to it's durable and low maintenance."
            },
            {
                subName: "Pink Fill Only",
                price: 30,
                detail: "This acrylic enhancement is classic, clean, and natural. The french tips dry instantly and stay shinner longer than polish. It is non-yellowing formula is applied in a double process with white powder for the free edge and pink powder for the nail bed."
            },
            {
                subName: "Shellac Gel Polish Manicure",
                price: 36,
                detail: "Your hands receives a Manicure and then are prepped for application of gel polish. The gel polish is cured with an LED light and the nails are instantly dry. The gel feels virtually weightless on your hands and lasts longer than regular nail polish. Many popular shades available. (No extra cost for old gel polish removal)."
            }
        ]
    },
    {
        id: 3,
        name:"Kid Services",
        image: "/assets/images/kid.gif",
        subServices: [
            {
                subName: "Manicure",
                price: 10,
                detail: ""
            },
            {
                subName: "Pedicure",
                price: 15,
                detail: ""
            },
            {
                subName: "Manicure & Pedicure",
                price: 20,
                detail: ""
            },
            {
                subName: "Gel Manicure",
                price: 24,
                detail: ""
            }
        ]
    },    
    {
        id: 4,
        name:"Waxing",
        image: "/assets/images/waxing.png",
        subServices: [
            {
                subName: "Eyebrows",
                price: 15,
                detail: ""
            },
            {
                subName: "Upper Lip",
                price: 10,
                detail: ""
            },
            {
                subName: "Chin",
                price: 10,
                detail: ""
            },
            {
                subName: "Side Burns",
                price: 10,
                detail: ""
            },
            {
                subName: "Full Face",
                price: 40,
                detail: ""
            },
            {
                subName: "Full Leg",
                price: 60,
                detail: ""
            },
            {
                subName: "Lower Legs",
                price: 30,
                detail: ""
            },
            {
                subName: "Half Arms",
                price: 28,
                detail: ""
            },
            {
                subName: "Full Arms",
                price: 45,
                detail: ""
            },
            {
                subName: "Under-Arms",
                price: 25,
                detail: ""
            },
            {
                subName: "Chest or Back",
                price: 50,
                detail: ""
            },
            {
                subName: "Bikini",
                price: 40,
                detail: ""
            }
        ]
    },
    {
        id: 5,
        name:"Facial",
        image: "/assets/images/facial.jpg",
        subServices: [
            {
                subName: "Anti-Aging Ultimate Lift",
                price: 150,
                detail: "Analysis of skin_ageLOC Gentle Cleanse & Tone is a luxurious foaming cleanser that combines cleansing and toning into a single step. It gently cleanses, purifies, replenishes, and hydrates skin, preparing it to receive advanced anti-aging ingradients_ Polishing Peel Microdermabrasion Skin Refinisher delivers skin smoothing results_Glacial Marine Mud Mask deposits more the 50 skin beneficial minerals and trace elements to nurture the skin."
            },
            {
                subName: "ACNE / Deep Cleansing Facial",
                price: 90,
                detail: "Analysis of skin - Clear Action Foaming Cleanser: Salicylic acid penetrates pores to eliminate most blemishes. Facial Sauna Treatment is important to open the pore to clean and loosen up the impurities hidden inside deep in the skin. Clay Pack Mask: ability to draw oils and impurities from the pores and helps to improve the tone and texture of the skin. Galvanic Spa -Detoxification Massage - Clean with hot towel - Clear Treatment: Mandelic acid helps reduce discoloration from post breakouts by gently exfoliating skin for a smoother, clearer appearance."
            },
            {
                subName: "Latic Acid Resurfacing Treatment",
                price: 50,
                detail: "Wipe away dull, aged skin in minutes Utilizing a 10% acid solution, this scientifically proven formula sweeps away the appearance of aging and sun damage without recovery time required by aggressive clinical peels. This powerful facial peel helps stimulate cell renewal and enhance collagen synthesis. The immediate benefits AHA Facial Peel will get your skin noticed."
            },
            {
                subName: "Vortex Peel Microdermabrasion",
                price: 200,
                detail: "All skin types except sensitive and reactive skin. Targets the most superficial layer of skin by projecting a well-guided and fully customized jet of pharmaceutical-grade corundum crystals onto a specific areas. The result is a beautifully resurfaced epidermis, a deep follicular pore cleansing and toned skin. Goal: smooth out fine lines and wrinkles, restore radiance, and blur imperfections (spots, hyperkeratosis, coarse skin, enlarged pores). Deeply cleanse the skin."
            }                         
        ]
    }
];